import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { User } from "@/types"

interface AuthState {
  user: User | null
  token: string | null
  roles: string[]
  loading: boolean
  error: string | null
  initialized: boolean
}

const initialState: AuthState = {
  user: null,
  token: null,
  roles: [],
  loading: false,
  error: null,
  initialized: false,
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<{ user: User | null; token?: string | null; roles?: string[] }>) => {
      state.user = action.payload.user
      state.token = action.payload.token || null
      state.roles = action.payload.roles || state.roles
      state.loading = false
      state.initialized = true
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.roles = []
      state.loading = false
      state.error = null
    },
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.initialized = action.payload
    },
  },
})

export const { setUser, setLoading, setError, logout, setInitialized } = authSlice.actions
export default authSlice.reducer
